module.exports = __webpack_public_path__ + "static/media/logo.72473d58.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ui/logo.png
// module id = 404
// module chunks = 0